import clsx from 'clsx';
import type { ReactNode } from 'react';

export interface IPanelProps {
  title?: string;
  titleAddon?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  variant?: 'default' | 'table';
  titleSpacing?: 'default' | 'loose';
}

const Panel = ({
  title,
  titleAddon,
  children,
  className,
  bodyClassName,
  variant = 'default',
  titleSpacing = 'default',
}: IPanelProps) => {
  if (variant === 'table') {
    return (
      <div
        className={clsx('rounded-xl border border-gray-200 bg-white overflow-hidden', className)}
      >
        {title ? (
          <div className='px-4 py-3 border-b border-gray-200'>
            <h2 className='text-xs font-semibold uppercase tracking-wide text-gray-500 m-0'>
              {title}
            </h2>
          </div>
        ) : null}
        <div className={clsx('overflow-x-auto', bodyClassName)}>{children}</div>
      </div>
    );
  }

  return (
    <div className={clsx('rounded-xl border border-gray-200 bg-white p-4 mb-6', className)}>
      {title ? (
        <h3
          className={clsx(
            'text-xs font-semibold uppercase tracking-wide text-gray-500',
            titleSpacing === 'loose' ? 'mb-4' : 'mb-3'
          )}
        >
          {title}
          {titleAddon ? (
            <span className='font-normal normal-case tracking-normal'>{titleAddon}</span>
          ) : null}
        </h3>
      ) : null}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
};

export default Panel;
